import { Dispatch, PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Actions } from '../../../store/actions';
import {
    hideDialog,
    swapPxElement,
    updateExamination,
    updateExaminationFindings,
} from '../../../store/actions/prescriptionPad';
import { GlobalState } from '../../../store/reducers';
import { getExaminations } from '../../../store/selectors/prescriptionPad';
import { ExaminationEntity } from '../../../store/types/prescription';
import { cloneAndDelete } from '../../../store/utils';
import ExaminationSearchInput, {
    EXAMINATION_FINDINGS_V2_AS_INPUT,
} from './ExaminationFindingsSearchInput';

import { CHANNEL_SUGGESTION, SELECT, track } from '../../../tracking';
import onContainerClick from '../../../pages/prescriptionPad/onClickContainer';
import { MedicalHistoryIcon } from '../../common/Icons';

import PadV2PxElementCard from '../rightPanel/workspace/padV2/PadV2PxElementCard';
import { ExaminationFindingsTableComponent } from './ExaminationFindingsTable';
import { PAD_V2_CONTAINER } from '../rightPanel/workspace/PadContainer';
import TemplateIcons from '../rightPanel/workspace/padV2/TemplateIcons';

type Props = {
    dispatch: Dispatch<Actions>;
    examinations: ExaminationEntity[];
    sectionName?: string;
};

const validActiveElements = new Set(['INPUT', 'TEXTAREA']);

class ExaminationFindingsCard extends PureComponent<Props> {
    MedicalHistoryIcon = MedicalHistoryIcon();

    onCancel = (event?: React.MouseEvent<HTMLButtonElement | HTMLDivElement>): void => {
        event?.stopPropagation();
        this.props.dispatch(hideDialog('exa'));
    };

    onItemSave = (option: ExaminationEntity, index?: number): void => {
        this.props.dispatch(updateExaminationFindings(option, index));

        track(SELECT, {
            element: 'Examination',
            channel: CHANNEL_SUGGESTION,
        });

        setTimeout(() => {
            const { examinations } = this.props;
            if (index == undefined || index === null || examinations.length - 1 === index) {
                if (
                    document.activeElement?.tagName &&
                    validActiveElements.has(document.activeElement?.tagName)
                ) {
                    return;
                }

                const t = document.getElementById(
                    EXAMINATION_FINDINGS_V2_AS_INPUT,
                ) as HTMLInputElement;
                t && t.focus();
            }
        }, 500);
    };

    onItemSwap = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }): void => {
        this.props.dispatch(swapPxElement('examinations', oldIndex, newIndex));
    };

    onItemDelete = (id: string): void => {
        this.props.dispatch(updateExamination(cloneAndDelete(id, this.props.examinations)));

        track('DELETE', {
            element: 'Examination',
        });
    };

    render(): ReactNode {
        const { examinations, sectionName } = this.props;

        return (
            <div onFocus={onContainerClick}>
                <PadV2PxElementCard
                    icon={this.MedicalHistoryIcon}
                    headingText={sectionName || 'Examination Findings'}
                    iconContainerBgClassName="bg-darwin-accent-examination-findings-sky-blue-900"
                    bodyCssClassName="space-y-8 rounded-8"
                    renderHeaderRight={() => (
                        <div className="flex mt-8 mr-16">
                            <div className="flex items-center space-x-16 ml-16">
                                <TemplateIcons
                                    pxToolKey={'examinations'}
                                    isModal={false}
                                    withPeak={true}
                                />
                            </div>
                        </div>
                    )}
                >
                    <ExaminationFindingsTableComponent
                        elements={examinations}
                        containerId={PAD_V2_CONTAINER}
                        onElementSelect={this.onItemSave}
                        onElementDelete={this.onItemDelete}
                        onDrag={this.onItemSwap}
                    />
                    <ExaminationSearchInput elements={examinations} onSelect={this.onItemSave} />
                </PadV2PxElementCard>
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    examinations: getExaminations(state),
}))(ExaminationFindingsCard);
